(function () {
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents, fmt) {
    var amount = cents / 100;
    var withCents = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var noCents = Math.round(amount).toString().replace(/\d(?=(\d{3})+$)/g, '$&,');
    return (fmt || '${{amount}}')
      .replace('{{amount}}', withCents)
      .replace('{{amount_with_comma_separator}}', withCents.replace('.', ','))
      .replace('{{amount_no_decimals}}', noCents)
      .replace('{{amount_no_decimals_with_comma_separator}}', noCents);
  }

  function makeToast(root, sel, msgSel) {
    var el = root.querySelector(sel);
    var msg = root.querySelector(msgSel);
    var timer = null;
    return function (text) {
      if (!el || !text) return;
      if (msg) msg.textContent = text;
      el.classList.add('is-visible');
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { el.classList.remove('is-visible'); }, 3400);
    };
  }

  function afterAdd() {
    fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true, detail: { baseEvent: 'ap:add', cart: cart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer, .cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else if (drawer && typeof drawer.open === 'function') drawer.open();
        else document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      })
      .catch(function () {});
  }

  function post(items, btns, labels, toast, errorLabel) {
    if (btns) btns.forEach(function (b) { b.disabled = true; });
    return fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (res) { if (!r.ok) throw res; return res; }); })
      .then(function () {
        afterAdd();
        if (!btns) return;
        btns.forEach(function (b) {
          var lbl = b.querySelector('[data-ap-atc-label]');
          if (!lbl) return;
          if (b.dataset.apLabel === undefined) b.dataset.apLabel = lbl.textContent;
          lbl.textContent = (labels && labels.added) || 'Added';
        });
        setTimeout(function () {
          btns.forEach(function (b) {
            var lbl = b.querySelector('[data-ap-atc-label]');
            if (lbl && b.dataset.apLabel !== undefined) lbl.textContent = b.dataset.apLabel;
          });
        }, 2200);
      })
      .catch(function (err) {
        toast((err && (err.description || err.message)) || errorLabel || 'Sorry, that could not be added to your cart.');
      })
      .then(function () { if (btns) btns.forEach(function (b) { b.disabled = false; }); });
  }

  function initHero(root) {
    if (root.dataset.apReady) return;
    root.dataset.apReady = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-ap-config]').textContent); } catch (e) { cfg = {}; }
    var toast = makeToast(root, '[data-ap-toast]', '[data-ap-toast-msg]');
    var qty = 1;

    function paint() {
      root.querySelectorAll('[data-ap-qty-val]').forEach(function (el) { el.textContent = qty; });
      root.querySelectorAll('[data-ap-line]').forEach(function (el) {
        el.textContent = money((cfg.price || 0) * qty, cfg.moneyFormat);
      });
    }

    root.querySelectorAll('[data-ap-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-ap-qty'), 10) || 0;
        qty = Math.max(1, Math.min(99, qty + step));
        paint();
      });
    });

    var atcBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ap-atc]'));
    atcBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cfg.variantId || cfg.available === false) return;
        post([{ id: cfg.variantId, quantity: qty }], atcBtns,
          { added: cfg.addedLabel }, toast, cfg.cartErrorLabel);
      });
    });

    root.querySelectorAll('[data-ap-add-one]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.getAttribute('data-ap-add-one'), 10);
        if (!id) return;
        post([{ id: id, quantity: 1 }], [btn], { added: cfg.addedLabel }, toast, cfg.cartErrorLabel);
      });
    });

    var sticky = root.querySelector('[data-ap-sticky]');
    if (sticky) {
      var footerVisible = false;
      var onScroll = function () {
        var past = (window.scrollY || window.pageYOffset || 0) > 600;
        if (past && !footerVisible) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      };
      var footer = document.querySelector('.shopify-section--footer, footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          onScroll();
        }, { rootMargin: '0px 0px 80px 0px' }).observe(footer);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    paint();
  }

  function initFinder(root) {
    if (root.dataset.apReady) return;
    root.dataset.apReady = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-ap-finder-config]').textContent); } catch (e) { cfg = {}; }
    var rules = cfg.rules || [];
    var toast = makeToast(root, '[data-ap-toast]', '[data-ap-toast-msg]');
    var state = { membrane: cfg.defaults && cfg.defaults.membrane, riser: cfg.defaults && cfg.defaults.riser, volume: cfg.defaults && cfg.defaults.volume };

    function match() {
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (r.membrane && r.membrane !== state.membrane) continue;
        if (r.risers && r.risers.length && r.risers.indexOf(state.riser) === -1) continue;
        if (r.volume && r.volume !== state.volume) continue;
        return r;
      }
      return rules[rules.length - 1] || null;
    }

    function setText(sel, text) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; });
    }

    var recBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ap-rec-atc]'));
    var current = null;

    function render() {
      root.querySelectorAll('[data-ap-answer]').forEach(function (btn) {
        var parts = btn.getAttribute('data-ap-answer').split(':');
        btn.classList.toggle('is-on', state[parts[0]] === parts[1]);
        btn.setAttribute('aria-pressed', state[parts[0]] === parts[1] ? 'true' : 'false');
      });

      var r = match();
      current = r;
      if (!r) return;

      setText('[data-ap-rec-name]', r.name);
      setText('[data-ap-rec-pack]', r.pack || '');
      setText('[data-ap-rec-price]', money(r.price || 0, cfg.moneyFormat));
      setText('[data-ap-rec-why]', r.why || '');

      var note = (r.note || '').replace(/\{riser\}/g, state.riser || '');
      var noteWrap = root.querySelector('[data-ap-rec-note-wrap]');
      setText('[data-ap-rec-note]', note);
      if (noteWrap) noteWrap.hidden = !note;

      root.querySelectorAll('[data-ap-rec-img]').forEach(function (img) {
        if (r.image) { img.src = r.image; img.alt = r.name || ''; img.hidden = false; }
        else { img.hidden = true; }
      });

      root.querySelectorAll('[data-ap-rec-link]').forEach(function (a) {
        if (r.url) { a.href = r.url; a.hidden = false; } else { a.hidden = true; }
      });

      recBtns.forEach(function (b) {
        var lbl = b.querySelector('[data-ap-atc-label]');
        delete b.dataset.apLabel;
        if (lbl) lbl.textContent = (cfg.addLabelPrefix || 'Add') + ' ' + r.name + (cfg.addLabelSuffix || '');
        b.disabled = !r.variantId || r.available === false;
      });
    }

    root.querySelectorAll('[data-ap-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parts = btn.getAttribute('data-ap-answer').split(':');
        state[parts[0]] = parts[1];
        render();
      });
    });

    recBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!current || !current.variantId || current.available === false) return;
        post([{ id: current.variantId, quantity: 1 }], recBtns,
          { added: cfg.addedLabel }, toast, cfg.cartErrorLabel);
      });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-ap]').forEach(initHero);
    document.querySelectorAll('[data-ap-finder]').forEach(initFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
